/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Entityscope1Inputs */

const en_entity_entityscope1 = /** @type {(inputs: Entity_Entityscope1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entity Scope`)
};

const de_entity_entityscope1 = /** @type {(inputs: Entity_Entityscope1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geltungsbereich`)
};

/**
* | output |
* | --- |
* | "Entity Scope" |
*
* @param {Entity_Entityscope1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_entityscope1 = /** @type {((inputs?: Entity_Entityscope1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Entityscope1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_entityscope1(inputs)
	return de_entity_entityscope1(inputs)
});
export { entity_entityscope1 as "entity_entityScope" }